import * as React from 'react';
import { useEffect, useState } from 'react';

import { ExperimentationUserDetails } from '../Models/ExperimentationUserDetails.csharp';

export const ExperimentsParamName = 'experiments';

export function resolveExperiments(component: HTMLElement | null): string[] {
    const experiments = [];

    if (!component) {
        return [];
    }

    let exp = getClosestExperimentField(component);
    while (exp) {
        if (exp.dataset.experiment) {
            experiments.push(exp.dataset.experiment);
        }

        if (!exp.parentElement) break;
        exp = getClosestExperimentField(exp.parentElement);
    }

    const globalExperiments = document.body.dataset.experiment;
    if (globalExperiments) {
        experiments.push(globalExperiments);
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    for (const experiment of urlParams.getAll(ExperimentsParamName)) {
        experiments.push(experiment);
    }

    return experiments;
}

const getClosestExperimentField = (component: HTMLElement): HTMLElement | null => component.closest('.Experiment');

export function addParameter(url: string, parameter: string, value: string): string {
    const param = parameter + '=' + value;
    if (url && (url.endsWith(param) || url.includes(param + '&'))) return url;

    const queryStart = url.indexOf('?');
    if (queryStart !== url.length) {
        url += queryStart > -1 ? '&' : '?';
    }

    url += param;
    return url;
}

export function useExperimentAwareUrl(url: string, ref: React.RefObject<HTMLElement | null>): string {
    const [expUrl, setExpUrl] = useState<string>(url);

    useEffect(() => {
        const experiments = resolveExperiments(ref.current);

        url = getExperimentAwareUrl(url, experiments);

        setExpUrl(url);
    }, []);

    return expUrl;
}

export function getExperimentAwareUrl(url: string, experiments: string[]) {
    if (url && experiments?.length > 0) {
        for (const experiment of experiments) {
            url = addParameter(url, ExperimentsParamName, experiment);
        }
    }

    return url;
}

export function useExperimentsForComponent(ref: React.RefObject<HTMLElement | null>): string[] {
    const [experiments, setExperiments] = useState<string[]>([]);

    useEffect(() => {
        setExperiments(resolveExperiments(ref.current));
    }, []);

    return experiments;
}

export function getUserInformation(): ExperimentationUserDetails {
    const getDevice = () => {
        if (window.innerWidth >= 1440) {
            return 'Desktop';
        }

        if (window.innerWidth >= 1024) {
            return 'Laptop';
        }

        if (window.innerWidth >= 768) {
            return 'Tablet';
        }

        return 'Mobile';
    };

    return {
        device: getDevice()
    };
}
